import type { Person, Project } from "@shared/types";

function rank(status: string): number {
  if (status === "active") return 1;
  if (status === "archived") return 99;
  return 2;
}

export function sortPeopleByStatus(rows: Person[]): Person[] {
  return [...rows].sort((a, b) => rank(a.status) - rank(b.status) || a.id - b.id);
}

export function sortProjectsByStatus(rows: Project[]): Project[] {
  return [...rows].sort((a, b) => rank(a.status) - rank(b.status) || a.id - b.id);
}
